import { render } from "./CreateCourse.vue?vue&type=template&id=6e52da97"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"

import "./CreateCourse.vue?vue&type=style&index=0&id=6e52da97&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__